/* @ngInject */
const trainIcons = () => {
  const self = {}

  self.train = 'train'
  self.tractionnaire = 'train'
  self.date = 'today'
  self.number = 'train'

  return self
}

export default trainIcons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/resources/icons.resource.js